import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    contactPreview: {
        width: '100%',
    },
    previewItem: {
        display: 'flex',
        marginBottom: theme.spacing(2),
        '&:last-child': {
            marginBottom: 0,
        },
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'flex-start',
        },
    },
    label: {
        fontWeight: 'bold',
        color: '#26344a',
        fontSize: '1.6rem',
        minWidth: '180px',
        marginRight: theme.spacing(2),
        flexShrink: 0,
        [theme.breakpoints.down('sm')]: {
            minWidth: 'auto',
            marginRight: 0,
            marginBottom: theme.spacing(1),
            fontSize: '1.4rem',
        },
    },
    value: {
        color: '#4a4a4a',
        fontSize: '1.6rem',
        lineHeight: 1.6,
        flex: 1,
        wordBreak: 'break-word',
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.4rem',
            width: '100%',
        },
    },
    messageValue: {
        color: '#4a4a4a',
        fontSize: '1.6rem',
        lineHeight: 1.6,
        flex: 1,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        backgroundColor: '#f9f9f9',
        padding: theme.spacing(2),
        borderRadius: '4px',
        border: '1px solid #e0e0e0',
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.4rem',
            width: '100%',
            padding: theme.spacing(1.5),
        },
    },
}));

const ContactPreview = ({ formData }) => {
    const classes = useStyles();

    if (!formData) return null;

    return (
        <Box className={classes.contactPreview}>
            <Box className={classes.previewItem}>
                <Typography variant="body1" className={classes.label}>
                    件名
                </Typography>
                <Typography variant="body1" className={classes.value}>
                    {formData.title}
                </Typography>
            </Box>

            <Box className={classes.previewItem}>
                <Typography variant="body1" className={classes.label}>
                    送信者名
                </Typography>
                <Typography variant="body1" className={classes.value}>
                    {formData.name}
                </Typography>
            </Box>

            <Box className={classes.previewItem}>
                <Typography variant="body1" className={classes.label}>
                    返信先メールアドレス
                </Typography>
                <Typography variant="body1" className={classes.value}>
                    {formData.email}
                </Typography>
            </Box>

            <Box className={classes.previewItem}>
                <Typography variant="body1" className={classes.label}>
                    本文
                </Typography>
                <Typography variant="body1" className={classes.messageValue}>
                    {formData.message}
                </Typography>
            </Box>
        </Box>
    )
}

ContactPreview.propTypes = {
    formData: PropTypes.object
}

export default ContactPreview
